import React from 'react'
import { MuiThemeProvider,createMuiTheme } from 'material-ui/styles'
import {observer,inject} from 'mobx-react'

import Messenger from './messenger'
import Cart from './cart'
import CartItemCount from './cartitemcount'

@inject('store','ui') @observer
class Layout extends React.Component {
  render () {
    const store = this.props.store.settings, ui = this.props.ui.colors
    const theme = createMuiTheme({
      palette: {
        primary:ui.getColor(store.primaryColor),
        secondary:ui.getColor(store.accentColor)
      }
    })

    return (
      <div>
       <MuiThemeProvider theme={theme}>
        <div className="width-100p height-100p">
         {this.props.children}
         <Cart />
         <CartItemCount />
         <Messenger />
        </div>
       </MuiThemeProvider>
      </div>
    )
  }
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/layout.js